import { Link } from "react-router-dom";

const VERB = { made: "made", ready: "marked ready", listed: "listed", batch: "uploaded batch" };
const when = (iso) => new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export default function TeamActivity({ items }) {
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-5" data-testid="team-activity">
      <p className="text-sm font-semibold text-slate-900">Assistant activity</p>
      {!items?.length ? (
        <p className="mt-1 text-xs text-slate-500" data-testid="team-activity-empty">Nothing yet. Drafts your assistants make, mark ready or list show here.</p>
      ) : (
        <ul className="mt-2 divide-y divide-slate-100">
          {items.map((a, i) => (
            <li key={`${a.at}-${i}`} className="py-2 text-xs text-slate-700" data-testid={`team-activity-row-${i}`}>
              <span className="font-semibold text-slate-900">{a.who?.name || a.who?.email}</span> {VERB[a.action] || a.action}{" "}
              {a.draft_id ? <Link to={`/?edit=${a.draft_id}`} className="text-[#0053DA] hover:underline">{a.title || "a draft"}</Link> : <span>{a.title}</span>}
              <span className="block font-mono text-[10px] text-slate-400">{when(a.at)}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
